import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import DemoPage from '@src/pages/Demo';

export const Route = createFileRoute('/demo')({
  head: () => buildSeoHead({ path: '/demo', ...ROUTE_META['/demo'] }),
  component: DemoPageWithLayout,
});

function DemoPageWithLayout() {
  return (
    <DefaultLayout>
      <DemoPage />
    </DefaultLayout>
  );
}
